var map = {
	"./decidim/avatar-multiuser.png": 38434,
	"./decidim/brands/google.svg": 39597,
	"./decidim/cc-badge.png": 60284,
	"./decidim/decidim-logo.svg": 81840,
	"./decidim/default-avatar.svg": 17448,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 71828,
	"./decidim/icons.svg": 9635,
	"./decidim/pattern.png": 86548,
	"./decidim/placeholder-card-g.svg": 62945,
	"./decidim/placeholder-card-l.svg": 54634,
	"./decidim/placeholder.jpg": 73977,
	"./decidim/remixicon.symbol.svg": 64909,
	"./decidim/vendor/leaflet/layers-2x.png": 21612,
	"./decidim/vendor/leaflet/layers.png": 26747,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 96406,
	"./decidim/vendor/leaflet/marker-icon.png": 29613,
	"./decidim/vendor/leaflet/marker-shadow.png": 6978,
	"./decidim/vendor/social-share-button/douban.svg": 73948,
	"./decidim/vendor/social-share-button/email.svg": 85817,
	"./decidim/vendor/social-share-button/facebook.svg": 41743,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 14929,
	"./decidim/vendor/social-share-button/hacker_news.svg": 4057,
	"./decidim/vendor/social-share-button/linkedin.svg": 3545,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 29530,
	"./decidim/vendor/social-share-button/pinterest.svg": 88159,
	"./decidim/vendor/social-share-button/reddit.svg": 35043,
	"./decidim/vendor/social-share-button/telegram.svg": 40118,
	"./decidim/vendor/social-share-button/tumblr.svg": 94005,
	"./decidim/vendor/social-share-button/twitter.svg": 76360,
	"./decidim/vendor/social-share-button/vkontakte.svg": 73542,
	"./decidim/vendor/social-share-button/wechat.svg": 3937,
	"./decidim/vendor/social-share-button/whatsapp.svg": 15881,
	"./decidim/vendor/social-share-button/x.svg": 56705,
	"./decidim/vendor/social-share-button/xing.svg": 94607
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51237;